class Header {
  init() {
    this.hamburger = document.querySelector("[js-hamburger]");
    this.mobileNav = document.querySelector(".header__nav");
    this.subMenuLink = document.querySelectorAll(".menu-item-has-children a");

    if (innerWidth <= 992) {
      this.headerMobileNav();
      this.submenuToggle();
    }

    $( '#room-tour-trigger-1' ).click(function() {
      $( ".iframe-wrapper-1" ).toggle( "slide" );
      $( ".iframe-wrapper-2" ).css(  "display", "none");
    });

    $( '#room-tour-trigger-2' ).click(function() {
      $( ".iframe-wrapper-2" ).toggle( "slide" );
      $( ".iframe-wrapper-1" ).css( "display", "none");
    });

    $( '.header__book-now' ).click(function() {
      $( ".booking-flyout" ).toggle( "slide-down" );
    });

    // $( '#booking-flyout' ).click(function(e) {
    //   e.preventDefault();
    //   $( ".booking-flyout" ).toggle( "slide-down" );
    // });

    $("#book-room-form-close").click(function() {
      $( ".booking-flyout" ).toggle( "slide-down" );
    });

    $( '#book-room-form-trigger' ).click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      $( ".book-a-room-form" ).toggle( "slide" );
      $( ".book-a-room-link" ).toggleClass( "open" );
      $("#book-room-form-back").toggleClass("hidden");
    });

    $("#book-room-form-back").click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      $( ".book-a-room-form" ).toggle( "slide" );
      $( ".book-a-room-link" ).toggleClass( "open" );
      $("#book-room-form-back").toggleClass("hidden");
    });

    $('#checkin-date').on('change', function () {
      var checkinDateString = $(this).val();
      var checkinDate = new Date();
      // var checkOutDate = new Date();
      
      checkinDate = Date.parse(checkinDateString);
      //  checkOutDateString = Date.parse(checkinDateString + 1);
      // var checkOutDate = new Date(checkinDate).setDate(+1);
      // // checkOutDate.setDate(checkinDate.getDate() + 1);
      // console.log('Checkout Day:');
      // console.log(checkOutDate);

      // console.log(checkinDate);
      // console.log(checkinDateString);


      const d = new Date(checkinDate);
      console.log('checkin date: ' + d);
      let day = d.getDate()
      let month = d.getMonth() + 1;
      let year = d.getFullYear();
      console.log(day);
      console.log(month);
      console.log(year);

      $('#checkin-day').val(day);
      $('#checkin-month').val(month);
      $('#checkin-year').val(year);

      // var checkOutDateString = new Date(checkOutDate);
      // console.log(checkOutDateString.getFullYear() + '-' + checkOutDateString.getMonth() + '-' + checkOutDateString.getDay());
      var newCheckOutDate = new Date(checkinDate);
      console.log('New Checkout Date after declaration: ' + newCheckOutDate);
      newCheckOutDate.setDate(newCheckOutDate.getDate() + 1);
      console.log('New Checkout Date after setDate: ' + newCheckOutDate);
      // newCheckOutDate.toString();
      // console.log('New Checkout Date after toString: ' + newCheckOutDate);
      // $('#checkout-date').val(newCheckoutDate.toISOString());
      // $('#checkout-date').trigger('change');


      // var checkOutDateString = new Date();
      // // console.log(checkOutDateString.getFullYear() + '-' + checkOutDateString.getMonth() + '-' + checkOutDateString.getDay());
      // checkOutDateString.setDate(checkOutDateString.getDate() + 1);
      // console.log('checkOutDateString: ' + checkOutDateString);
      let checkOutDay = newCheckOutDate.getDate();
      let checkOutMonth = newCheckOutDate.getMonth() + 1;
      let checkOutYear = newCheckOutDate.getFullYear();

      if (checkOutDay < 10) {
        checkOutDay = '0' + checkOutDay;
      }

      if (checkOutMonth < 10) {
        checkOutMonth = `0${checkOutMonth}`;
      }

      // checkOutDateString.setDate(year + '-' + month + '-' + day);

      // var newCheckoutDate = new Date();
      // newCheckoutDate.setDate(year + '-' + checkOutMonth + '-' + checkOutDay);
      // console.log('New Checkout Date: ' + checkOutDateString);
      $('#checkout-date').val(checkOutYear + '-' + checkOutMonth + '-' + checkOutDay);
      $('#checkout-date').trigger('change');
      
      
   });

   $('#checkout-date').on('change', function () {
    // var date1 = new Date("06/30/2019");
    // var date2 = new Date("07/30/2019");


    var checkinDateString = $('#checkin-date').val();
    var checkOutDateString = $(this).val();

    const checkinDate = new Date(checkinDateString);
    const checkOutDate = new Date(checkOutDateString);

      
    // To calculate the time difference of two dates
    var Difference_In_Time = checkOutDate.getTime() - checkinDate.getTime();
      
    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    $('#num-nights').val(Difference_In_Days);
      
   });
   $('.book-a-room-form input[type="submit"]').on('click', function(e) {
      e.preventDefault();

      var dayIn = $('#checkin-day').val();
      var monthIn = $('#checkin-month').val();
      var yearIn = $('#checkin-year').val();
      var numNights = $('#num-nights').val();
      var adults = $('#adults').val();
      var children = $('#children').val();

      var bookingUrl = 'https://all.accor.com/lien_externe.svlt?goto=rech_resa&destination=9227&dayIn=' + dayIn + '&monthIn=' + monthIn + '&yearIn=' + yearIn + '&nightNb=' + numNights +'&adultNumber=' + adults +'&childrenNumber=' + children;

      if ( children != 0) {
        var totalChildren = children;
        var childAges = new Array();
        var child1Age = $('#child-1').val();
        var child2Age = $('#child-2').val();
        var child3Age = $('#child-3').val();
        var child4Age = $('#child-4').val();
        var child5Age = $('#child-5').val();
        var child6Age = $('#child-6').val();
        var rawAges = new Array(child1Age, child2Age, child3Age, child4Age, child5Age, child6Age);

        var child = 0;

        for ( child = 0; child < totalChildren; child++ ) {
            childAges[child] = rawAges[child];

            bookingUrl = bookingUrl + '&childrenAge' + child + '=' + childAges[child];

        }
      }

      bookingUrl = bookingUrl + '&code_langue=en8';

      window.open(bookingUrl, '_blank').focus();
      console.log('URL: ' + bookingUrl);
    });

    $('.minus').click(function () {
      var $input = $(this).parent().find('input');
      var count = parseInt($input.val()) - 1;
      count = count < 0 ? 0 : count;
      $input.val(count);
      $input.change();
      return false;
    });

    $('.plus').click(function () {
      var $input = $(this).parent().find('input');
      $input.val(parseInt($input.val()) + 1);
      $input.change();
      return false;
    });

    $('.tool-tip-icon').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).next('.tool-tip').toggleClass('hide');
    });

    $('input.adults').on('keydown', function(e) {
      e.preventDefault();
      console.log('key down');
    });
  }

  headerMobileNav() {
    if (this.hamburger) {
      this.hamburger.addEventListener("click", () => {
        this.hamburger.classList.toggle("is-active");
        this.mobileNav.classList.toggle("is-active");
        document.body.classList.toggle("overflow-hidden");
      });
    }
  }

  submenuToggle() {
    if (this.subMenuLink.length) {
      this.subMenuLink.forEach((link) => {
        link.addEventListener("click", () => {
          link.nextElementSibling.classList.toggle("is-active");
        });
      });
    }
  }
}

export default Header;



// WEBPACK FOOTER //
// ./scripts/Header.js